import { useMutation } from '@tanstack/react-query';

import { approveListOneTicketApi } from '../api';

export default function useApproveListOneTicketMutation(options?: any) {
  return useMutation(approveListOneTicketApi, options);
}
